import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const services = [
    {
      title: 'Focus Consultoria',
      description: 'Soluções personalizadas em consultoria empresarial para impulsionar o crescimento do seu negócio.',
      icon: '🎯',
      link: '/focus-consultoria',
      color: 'bg-focus-blue'
    },
    {
      title: 'Focus Organiza',
      description: 'Organização empresarial e otimização de processos para maior eficiência operacional.',
      icon: '📊',
      link: '/focus-organiza',
      color: 'bg-focus-orange'
    },
    {
      title: 'Focus Coaching',
      description: 'Coaching individual e em grupo para desenvolvimento pessoal e profissional.',
      icon: '🚀',
      link: '/focus-coaching',
      color: 'bg-focus-blue'
    },
    {
      title: 'Focus Palestras',
      description: 'Palestras motivacionais e educativas para inspirar e capacitar suas equipes.',
      icon: '🎤',
      link: '/focus-palestras',
      color: 'bg-focus-orange'
    }
  ];

  const testimonials = [
    {
      name: 'Maria Silva',
      company: 'Empresa ABC Ltda',
      text: 'A Focus transformou completamente nossa gestão empresarial. Os resultados foram impressionantes!',
      rating: 5
    },
    {
      name: 'João Santos',
      company: 'Indústria XYZ',
      text: 'O coaching oferecido pela Focus foi fundamental para o desenvolvimento da nossa liderança.',
      rating: 5
    },
    {
      name: 'Ana Costa',
      company: 'Comércio 123',
      text: 'As palestras da Focus motivaram toda nossa equipe. Recomendo para todas as empresas!',
      rating: 5
    }
  ];

  return (
    <main id="main-content" className="pt-32"> {/* Espaço para header fixo */}
      {/* Banner Principal */}
      <section className="bg-gradient-to-r from-focus-blue to-blue-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Transforme seu <span className="text-focus-pink">Negócio</span> com a Focus
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl mx-auto">
            Consultoria, treinamento e coaching empresarial para levar sua empresa ao próximo nível
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/focus-consultoria"
              className="bg-focus-orange hover:bg-red-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Conheça Nossos Serviços
            </Link>
            <a
              href="#contato"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-focus-blue text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Entre em Contato
            </a>
          </div>
        </div>
      </section>

      {/* Seção de Serviços */}
      <section className="py-20 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Nossos Serviços
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos soluções completas para o desenvolvimento e crescimento da sua empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow group"
              >
                <div className={`${service.color} w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform`}>
                  {service.icon}
                </div>
                <h3 className="text-xl font-semibold text-focus-blue mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {service.description}
                </p>
                <Link
                  to={service.link}
                  className="text-focus-orange hover:text-red-600 font-semibold transition-colors"
                >
                  Saiba mais →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seção de Números */}
      <section className="py-20 bg-focus-blue text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-blue-200">Empresas Atendidas</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">15+</div>
              <div className="text-blue-200">Anos de Experiência</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">1000+</div>
              <div className="text-blue-200">Profissionais Treinados</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">98%</div>
              <div className="text-blue-200">Satisfação dos Clientes</div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Depoimentos */}
      <section className="py-20 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              O que nossos clientes dizem
            </h2>
            <p className="text-lg text-gray-600">
              Veja os depoimentos de quem já transformou seu negócio conosco
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600 mb-4 italic">
                  "{testimonial.text}"
                </p>
                <div>
                  <div className="font-semibold text-focus-blue">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-500">
                    {testimonial.company}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section id="contato" className="py-20 bg-focus-orange text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto para transformar seu negócio?
          </h2>
          <p className="text-xl mb-8 text-red-100 max-w-2xl mx-auto">
            Entre em contato conosco e descubra como podemos ajudar sua empresa a alcançar novos patamares
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+55619170-8150"
              className="bg-white text-focus-orange hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              📞 (61) 9170-8150
            </a>
            <a
              href="mailto:focusconsultoriaecursos@gmail.com "
              className="bg-transparent border-2 border-white hover:bg-white hover:text-focus-orange text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              ✉️ focusconsultoriaecursos@gmail.com
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;